// removed by extract-text-webpack-plugin
module.exports = {"classtop-loading":"classtop-loading","loading-curtain":"loading-curtain","loading-content":"loading-content","loading-icon":"loading-icon","lds-ring":"lds-ring","lds-facebook":"lds-facebook"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Loading/Loading.scss
// module id = OLUV
// module chunks = 0